const isPromise = v => Object.prototype.toString.call(v) === '[object Promise]'

export default {
  name:'Download',
  props:{
    click:null,
    type:{
      type:String,
      default:'default'
    },
    icon:{
      type:String,
      default:'md-download'
    },
    params:Object
  },
  data(){
    return {
      loading:false
    }
  },
  methods:{
    handleExport(){
      if( this.click ){
        this.loading = true
        
        Promise.resolve(this.click()).then(resp => {
          this.loading = false
        })
      }
    }
  },
  render(){
    return <Button type={this.type} loading={this.loading} icon={this.icon} on-click={this.handleExport}>导出</Button>
  }
}